<template>
    <el-dialog :title="title" :visible.sync="showModal" :close-on-click-modal="false" :destroy-on-close="true"
        width="42%">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="通知标题" prop="title">
                <el-input v-model="form.title"></el-input>
            </el-form-item>

            <el-form-item label="通知描述" prop="content">
                <el-input type="textarea" :rows="4" placeholder="请输入介绍内容" v-model="form.content" />
            </el-form-item>

            <el-form-item label="跳转类型" prop="link_type">
                <el-select v-model="form.link_type" @change="onChangeLinkType">
                    <el-option label="活动" :value="1" />
                    <el-option label="测评商品" :value="2" />
                    <el-option label="公众号文章" :value="3" />
                    <el-option label="平台内文" :value="4" />
                    <el-option label="无跳转" :value="5" />
                </el-select>
            </el-form-item>

            <el-form-item v-if="form.link_type === 1" label="请选择活动" prop="link_to">
                <el-select v-loading="activityLoading" v-model="form.link_to" style="width: 100%;max-width: 220px;">
                    <el-option v-for="(type, tIndex) in activityList" :key="`type_${tIndex}`" :label="type.title"
                        :value="type.id" />
                </el-select>
            </el-form-item>

            <el-form-item v-else-if="form.link_type === 2" label="测评商品" prop="link_to">
                <el-select v-loading="activityLoading" v-model="form.link_to" filterable>
                    <el-option v-for="(type, tIndex) in activityList" :key="tIndex" :label="type.name"
                        :value="type.id" />
                </el-select>
            </el-form-item>

            <el-form-item v-else-if="form.link_type === 3" label="跳转链接" prop="link_to">
                <el-input v-model="form.link_to" />
            </el-form-item>

            <el-form-item v-else-if="form.link_type === 4" label="平台文章" prop="link_to">
                <el-select v-loading="activityLoading" v-model="form.link_to" filterable>
                    <el-option v-for="(type, tIndex) in activityList" :key="tIndex" :label="type.title"
                        :value="type.id" />
                </el-select>
            </el-form-item>

            <el-form-item label="发布时间" prop="release_at">
                <el-date-picker v-model="form.release_at" type="datetime" format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm:ss" />
            </el-form-item>
            <el-form-item label="备注：">
                <div class="remark">
                    <span>1.新建时，发布时间需<strong style="color:red;">大于</strong>当前时间</span>
                    <span>2.新建后，点击<strong style="color:red;">右侧发布按钮</strong>即可<strong
                            style="color:red;">按时发布</strong>该通知</span>
                    <span>3.点击发布后,需当前时间大于发布时间，才会在小程序中接收该通知</span>
                </div>

            </el-form-item>
            <el-row type="flex" justify="end">
                <el-button @click="trunOff">取消</el-button>
                <el-button type="primary" :loading="submitting" @click="onSubmit">确认</el-button>
            </el-row>
        </el-form>
    </el-dialog>
</template>

<script>
import { notification, banner } from "@/api/operation"

export default {
    data: () => ({
        // 表单规则
        rules: {
            title: [
                { required: true, message: "请输入通知标题", trigger: 'blur' }
            ],
            content: [
                { required: true, message: "请输入通知描述", trigger: 'blur' }
            ],
            link_type: [
                { required: true, message: "请选择跳转类型", trigger: 'blur' },
            ],
            link_to: [
                { required: true, message: "请选择或输入链接", trigger: 'blur' }
            ],
            release_at: [
                { required: true, message: "请选择发布时间", trigger: 'blur' }
            ]
        },
        // 表单数据字段
        form: {
            title: '',
            content: '',
            link_type: null,
            link_to: null,
            release_at: ''
        },
        submitting: false,
        activityLoading: false,
        activityList: []
    }),
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        },
        // 模式
        type: {
            default: 'add',
            type: String
        },
        // 编辑的数据
        editData: null | Object
    },
    methods: {
        // 自我关闭
        trunOff() {
            this.showModal = false
        },
        handleUpdateFormModelByModalType() {
            const handlers = {
                add: () => {
                    this.form = {
                        title: '',
                        content: '',
                        link_type: '',
                        link_to: '',
                        release_at: ''
                    }
                },
                edit: () => {
                    const { id, title, content, link_type, link_to, release_at } = this.editData
                    this.form = {
                        id,
                        title,
                        content,
                        link_type,
                        link_to: [3, 5].includes(link_type) ? link_to : Number(link_to),
                        release_at
                    }
                }
            }

            handlers[this.type]()
            // console.log('走到这')
            this.getNavigationType(this.editData.link_type, this.type == "edit")
        },
        onChangeLinkType(type) {
            console.log('这里')
            this.getNavigationType(type)
        },
        async getNavigationType(link_type, noClear = false) {
            if (!noClear) this.form.link_to = ''
            if (link_type === 3 || link_type === 5) return

            this.activityLoading = true

            const { data } = await banner.navigationType(link_type)

            this.activityList = data

            this.activityLoading = false
        },
        onSubmit() {
            const { form } = this

            const handlers = {
                add: () => {
                    this.$refs["form"].validate(async valid => {
                        if (valid) {
                            this.submitting = true
                            try {
                                await notification.create(form)
                                this.trunOff()
                                this.$message({
                                    message: '添加成功!',
                                    type: 'success'
                                });
                                this.$emit('success')
                            } catch {
                                this.$message.error('添加失败!')
                            } finally {
                                this.submitting = false
                            }
                        }
                    })
                },
                edit: () => {
                    this.$refs["form"].validate(async valid => {
                        if (valid) {
                            this.submitting = true
                            try {
                                await notification.create(form)
                                this.trunOff()
                                this.$message({
                                    message: '编辑成功!',
                                    type: 'success'
                                });
                                this.$emit('success')
                            } catch {
                                this.$message.error('编辑失败!')
                            } finally {
                                this.submitting = false
                            }
                        }
                    })
                }
            }

            handlers[this.type]()
        }
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        },
        title() {
            const { type } = this

            const title = {
                add: "新建数据",
                edit: "编辑数据"
            }

            return title[type]
        }
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.handleUpdateFormModelByModalType()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.remark {
    display: flex;
    flex-direction: column;
}
</style>